import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function FilterBar({ onSearchChange, searchValue, onReset, onExport, actions, exactMatch, onExactMatchChange, children }) {
    return (_jsxs("section", { style: {
            background: "linear-gradient(180deg, rgba(16,185,129,.06), rgba(16,185,129,.02))",
            border: "1px solid var(--border)",
            borderRadius: 12,
            padding: 16,
            display: "flex",
            flexDirection: "column",
            gap: 12,
        }, children: [_jsxs("div", { style: { display: "flex", gap: 10, alignItems: "center" }, children: [_jsx("input", { type: "search", placeholder: "Pesquisar...", value: searchValue ?? "", onChange: (e) => onSearchChange?.(e.target.value), style: {
                            flex: 1,
                            background: "transparent",
                            border: "1px solid var(--border-strong)",
                            borderRadius: 10,
                            padding: "10px 14px",
                            color: "var(--text)",
                            fontSize: 14,
                            outline: "none",
                        } }), onExactMatchChange ? (_jsxs("label", { style: { display: "flex", alignItems: "center", gap: 6, fontSize: 12, color: "var(--text-muted)", whiteSpace: "nowrap" }, children: [_jsx("input", { type: "checkbox", checked: exactMatch, onChange: (e) => onExactMatchChange(e.target.checked) }), "Pesquisar termo exato"] })) : null] }), children, _jsxs("div", { style: { display: "flex", gap: 10, alignItems: "center", flexWrap: "wrap" }, children: [actions, _jsxs("div", { style: { marginLeft: "auto", display: "flex", gap: 8 }, children: [onReset ? (_jsx("button", { type: "button", onClick: onReset, style: btnGhost, children: "\u21BB REINICIAR FILTROS" })) : null, onExport ? (_jsx("button", { type: "button", onClick: onExport, style: btnGhost, children: "\u2B07 EXPORTAR DADOS" })) : null] })] })] }));
}
const btnGhost = {
    padding: "8px 14px",
    borderRadius: 8,
    border: "1px solid var(--border-strong)",
    background: "transparent",
    color: "var(--text)",
    fontWeight: 600,
    fontSize: 12,
    letterSpacing: "0.05em",
    cursor: "pointer",
};
export function FilterCheckboxGroup({ options, selected, onChange }) {
    return (_jsx("div", { style: { display: "flex", gap: 16, flexWrap: "wrap" }, children: options.map((o) => {
            const isOn = selected.has(o.value);
            return (_jsxs("label", { style: { display: "flex", alignItems: "center", gap: 6, fontSize: 13, color: "var(--text-muted)", cursor: "pointer" }, children: [_jsx("input", { type: "checkbox", checked: isOn, onChange: () => {
                            const next = new Set(selected);
                            if (isOn)
                                next.delete(o.value);
                            else
                                next.add(o.value);
                            onChange(next);
                        } }), o.label] }, o.value));
        }) }));
}
//# sourceMappingURL=FilterBar.js.map